/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesOfficesResponseSalesOfficeName } from './SalesOfficesResponseSalesOfficeName';
import {
    SalesOfficesResponseSalesOfficeNameFromJSON,
    SalesOfficesResponseSalesOfficeNameFromJSONTyped,
    SalesOfficesResponseSalesOfficeNameToJSON,
    SalesOfficesResponseSalesOfficeNameToJSONTyped,
} from './SalesOfficesResponseSalesOfficeName';

/**
 * 
 * @export
 * @interface SalesOfficesResponse
 */
export interface SalesOfficesResponse {
    /**
     * 営業所一覧
     * @type {Array<SalesOfficesResponseSalesOfficeName>}
     * @memberof SalesOfficesResponse
     */
    salesOffices: Array<SalesOfficesResponseSalesOfficeName>;
}

/**
 * Check if a given object implements the SalesOfficesResponse interface.
 */
export function instanceOfSalesOfficesResponse(value: object): value is SalesOfficesResponse {
    if (!('salesOffices' in value) || value['salesOffices'] === undefined) return false;
    return true;
}

export function SalesOfficesResponseFromJSON(json: any): SalesOfficesResponse {
    return SalesOfficesResponseFromJSONTyped(json, false);
}

export function SalesOfficesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOfficesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'salesOffices': ((json['salesOffices'] as Array<any>).map(SalesOfficesResponseSalesOfficeNameFromJSON)),
    };
}

export function SalesOfficesResponseToJSON(json: any): SalesOfficesResponse {
    return SalesOfficesResponseToJSONTyped(json, false);
}

export function SalesOfficesResponseToJSONTyped(value?: SalesOfficesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'salesOffices': ((value['salesOffices'] as Array<any>).map(SalesOfficesResponseSalesOfficeNameToJSON)),
    };
}

